import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { OrdersService } from '../../services';
import { AuthActionTypes, KpiActionTypes } from '@app/core/ngrx';
import { Actions, ofType, createEffect } from '@ngrx/effects';

/**
 * OrdersEpics
 */
@Injectable()
export class KpiEffects {
  /**
   * constructor
   * @param {OrdersService} ordersService
   */
  constructor(
    private ordersService: OrdersService,
    private actions$: Actions,
  ) {}

  /**
   * loadKpi
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadKpi = createEffect(() =>
    this.actions$.pipe(
      ofType(KpiActionTypes.LOAD_KPI),
      switchMap(({ payload }: any) => {
        return this.ordersService
          .getOrderMetrics(payload.location, payload.dateFrom, payload.dateTo)
          .pipe(
            map(kpis => ({
              type: KpiActionTypes.LOAD_KPI_SUCCESS,
              payload: kpis,
            })),
            catchError(err =>
              of({ type: KpiActionTypes.LOAD_KPI_ERROR, payload: err }),
            ),
          );
      }),
    ),
  );

  /**
   * loadKpiError
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadOrdersError = createEffect(() =>
    this.actions$.pipe(
      ofType(KpiActionTypes.LOAD_KPI_ERROR),
      map(() => ({ type: AuthActionTypes.LOGOUT })),
    ),
  );
}
